var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchShapes = function SvgSearchShapes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-140v-320h320v320zm80-80h160v-160H160zm60-340 220-360 220 360zm142-80h156l-78-126zM863-42 757-148q-21 14-45.5 21t-51.5 7q-75 0-127.5-52.5T480-300t52.5-127.5T660-480t127.5 52.5T840-300q0 26-7 50.5T813-204L919-98zM731-229q29-29 29-71t-29-71-71-29-71 29-29 71 29 71 71 29 71-29M440-640"
  })));
};
export default SvgSearchShapes;